module.exports = __webpack_public_path__ + "56d85f1520a9e57d429eea8d5670e5dc.png";